import ReactMarkdown from "react-markdown";

import { FLOW_MARKDOWN_HEADING_CLASS as HEADING_CLASS } from "@/components/ui/flow-component-header";

type FlowMarkdownProps = {
  content: string;
};

// QL-296 — every heading level renders as THE flow component header style
// (DESIGN.md › Flow component headers), so a heading inside a text block
// matches the title of the widget next to it. The editor offers exactly one
// heading (`headings="single"`, which creates `###`); older content keeps its
// `#` or `##` and renders the same, so no migration is needed.

/**
 * Markdown renderer shared by the text_block and modal flow components,
 * so both render identical formatting.
 */
export function FlowMarkdown({ content }: FlowMarkdownProps) {
  return (
    <div className="prose dark:prose-invert max-w-none">
      <ReactMarkdown
        components={{
          h1: ({ node, ...props }) => <h1 className={HEADING_CLASS} {...props} />,
          h2: ({ node, ...props }) => <h2 className={HEADING_CLASS} {...props} />,
          h3: ({ node, ...props }) => <h3 className={HEADING_CLASS} {...props} />,
          h4: ({ node, ...props }) => <h4 className={HEADING_CLASS} {...props} />,
          h5: ({ node, ...props }) => <h5 className={HEADING_CLASS} {...props} />,
          h6: ({ node, ...props }) => <h6 className={HEADING_CLASS} {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc ml-6 my-2" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal ml-6 my-2" {...props} />,
          li: ({ node, ...props }) => <li className="my-1" {...props} />,
          p: ({ node, ...props }) => <p className="my-2" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-bold" {...props} />,
          em: ({ node, ...props }) => <em className="italic" {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
